export type ElevationCode = 'front' | 'right' | 'rear' | 'left';
export type BracketColor = 'amber' | 'pink' | 'blue';

export interface ShotContext {
  category: string;
  label: string;
  description: string;
  elevation: ElevationCode | null;
  bracketColor: BracketColor;
  locked: boolean;
}

export interface CapturedPhoto {
  id: string;            // UUID v4
  blobKey: string;       // key into blobStore
  checksum: string;      // sha256 hex (lowercase)
  capturedAt: string;    // ISO 8601 UTC
  context: ShotContext;
  flagged: boolean;
  noteText: string;
}

export interface ElevationCounts {
  front: number;
  right: number;
  rear: number;
  left: number;
}

export const EMPTY_ELEVATION_COUNTS: ElevationCounts = {
  front: 0,
  right: 0,
  rear: 0,
  left: 0,
};
